import React from 'react'
import { Col, Collapse, Row, Table, Tabs, Radio, Carousel } from "antd";
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

// Components
import Container from "../../../../containers/Container";
import InfoTramQT from "../../../../components/License/BieuDo/MauQTTram"
import Api_quantrac from "../../../../api/api.quantrac"
const { Panel } = Collapse;
const { TabPane } = Tabs;
class DeAnDetail extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: {},
        }
    }

    componentDidMount() {

    }

    render() {
        const { idTramQuanTrac, editable, user } = this.props;
        return (
            <Container>
                <InfoTramQT
                    user={user}
                    phanloai="HTMT"
                    idTramQuanTrac={idTramQuanTrac}
                    editable={editable}
                    apiGetTPMT_Exist={new Api_quantrac().GetTPMT_Exist_HTMT}
                    apiGetMauQT_by_Tram={new Api_quantrac().GetMauQTs_By_TramQT_HTMT}
                    apiSoLan_VuotNguong={new Api_quantrac().GetBieuDo_SoLanVuotNguong_HTMT}
                    apiThongSo_Exist={new Api_quantrac().GetThongSos_Exist_HTMT}
                    apiGiaTriTimeLine={new Api_quantrac().GetBieuDo_ThongSos_GiaTris_Timeline_HTMT}
                />
            </Container>
        )
    }
}

DeAnDetail.propTypes = {
    idGiayPhep: PropTypes.string
};


const mapStateToProps = (state) => ({
    user: state.oidc.user
});

export default connect(mapStateToProps)(DeAnDetail)